import React from "react";
import "./SocialMedia.scss";
import {socialMediaLinks} from "../../portfolio";

export default function socialMedia() {
  if (!socialMediaLinks.display) {
    return null;
  }
  return (
    <div className="social-media-div">
      {socialMediaLinks.github ? (
        <a
          href={socialMediaLinks.github}
          className="icon-button github"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-github"></i>
          <span></span>
        </a>
      ) : null}

      {socialMediaLinks.linkedin ? (
        <a
          href={socialMediaLinks.linkedin}
          className="icon-button linkedin"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-linkedin-in"></i>
          <span></span>
        </a>
      ) : null}

      {socialMediaLinks.email ? (
        <a
          href={`mailto:${socialMediaLinks.email}`}
          className="icon-button email"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-envelope"></i>
          <span></span>
        </a>
      ) : null}

      {socialMediaLinks.portfolio ? (
        <a
          href={socialMediaLinks.portfolio.startsWith("http") ? socialMediaLinks.portfolio : "https://" + socialMediaLinks.portfolio}
          className="icon-button portfolio"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-globe"></i>
          <span></span>
        </a>
      ) : null}
    </div>
  );
}
